import { render, staticRenderFns } from "./BdMessage.vue?vue&type=template&id=3707cb3c&scoped=true&"
import script from "./BdMessage.vue?vue&type=script&lang=js&"
export * from "./BdMessage.vue?vue&type=script&lang=js&"
import style0 from "./BdMessage.vue?vue&type=style&index=0&id=3707cb3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3707cb3c",
  null
  
)

export default component.exports